@import '../../../../../../constants/spacing.module.less';

.preview-data-cell {
  overflow: hidden;
}

.content {
  display: flex;
  align-items: center;
}

.header-title {
  padding: @space-0 @space-8;
}

.select-data {
  padding: @space-0 @space-4;
}

.chevron-icon {
  width: 7px;
  color: var(--grey-600);
  cursor: pointer;

  &.inactive {
    color: var(--grey-400);
    cursor: default;
  }
}
